export const CHANGE_STATUS_SOCKET = "CHANGE_STATUS_SOCKET";
export const SET_SOCKET = "SET_SOCKET";
export const CHANGE_ID = "CHANGE_ID";
export const DISCONNECT = "DISCONNECT";
export const RECONNECT = "RECONNECT";

export const CHANGE_CHECKED = "CHANGE_CHECKED";

export const SHOW_SETTING = "SHOW_SETTING";
export const SHOW_MANAGE = "SHOW_MANAGE";
export const SHOW_MAP_LAYER = "SHOW_MAP_LAYER";

export const GET_ALL_DUONG = "GET_ALL_DUONG";
export const GET_ALL_PHUONG = "GET_ALL_PHUONG";
export const GET_ALL_QUAN = "GET_ALL_QUAN";
export const GET_ALL_LOAI_PHONG_BAN = "GET_ALL_LOAI_PHONG_BAN";

export const GET_ALL_DU_AN = "GET_ALL_DU_AN";
export const SHOW_CHART = "SHOW_CHART";

export const GET_ALL_DU_AN_VKT = "GET_ALL_DU_AN_VKT";

export const SHOW_MENU = "SHOW_MENU";

export const CHANGE_ENABLE_LAYER = "CHANGE_ENABLE_LAYER ";
export const RESET_LAYER = "RESET_LAYER ";
export const RESET_LAYER_ALL = "RESET_LAYER_ALL ";
export const CHANGE_DISABLE_LAYER = 'CHANGE_DISABLE_LAYER'
export const GET_ALL_TEN_LOAI_DAT = "GET_ALL_TEN_LOAI_DAT"

export const SHOW_MENU_POPUP = "SHOW_MENU_POPUP"

// auth

export const GET_AUTH = "GET_AUTH"
